import { endpoint, openURL } from './utils';

/**
 * Opens an email invite for the given link data
 * @param {Object} linkData - The link data containing title, url, and type
 * @param {string} linkData.title - The title of the link
 * @param {string} linkData.url - The URL of the link
 * @param {string} linkData.type - The type of invite ('meeting' or 'user')
 * @param {Function} onError - Callback function to handle errors
 * @returns {Promise<void>}
 */
export const openEmailInvite = async (linkData, onError) => {
  try {
    const { title, url, type = 'meeting' } = linkData;
    
    // Build the email invite URL with appropriate parameters
    const params = new URLSearchParams({
      title: title || (type === 'meeting' ? 'Untitled Meeting' : 'User Invitation'),
      url: url,
      type: type
    });
    
    const inviteUrl = `https://${endpoint()}/zoom-phone/email-invite?${params.toString()}`;
    
    await openURL(inviteUrl);
  } catch (error) {
    console.error('Error opening email invite:', error);
    if (onError) {
      onError(error);
    }
  }
};

/**
 * Hook for email invite functionality
 * @param {Function} onError - Callback function to handle errors
 * @returns {Object} - Object containing the openEmailInvite function
 */
export const useEmailInvite = (onError) => {
  return {
    openEmailInvite: (linkData) => openEmailInvite(linkData, onError)
  };
};
